import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useUserActions} from "../service/user.actions";
import {WarningAmberRounded} from "@mui/icons-material";

const SessionExpiredDialog = () => {
    const {t} = useTranslation();
    const userActions = useUserActions();

    const handleClose = () => {
        userActions.logout();
    };

    return (
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            disableEscapeKeyDown={true}
        >
            <DialogTitle id="responsive-dialog-title" sx={{display: 'flex', justifyContent: 'center'}}>
                {t('error.sessionExpired')}
                <WarningAmberRounded color={'error'}/>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('error.sessionExpiredMessage')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {t('info.ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SessionExpiredDialog;